import { useMemo } from 'react'
import { useSessionData } from 'src/hook/useSessionData'
import { useUserProfileEvents } from 'src/hook/useUserProfileEvents'
import { useUserProfileStore } from 'src/store'

const useUserProfile = () => {
  const { onClose, onOpen } = useUserProfileEvents()
  const store = useUserProfileStore()
  const { user } = useSessionData()
  const isSessionUserProfile = useMemo(() => {
    return !store?.userUcode || store?.userUcode === user?.ucode
  }, [store, user])

  return {
    ...store,
    isSessionUserProfile,
    loggedUserUcode: user?.ucode,
    onOpen,
    onClose
  }
}

export default useUserProfile
